var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timelapse",
    clipPath: "url(#clip0_6158_35528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8263 5.16666C10.0463 4.38666 9.02634 3.99333 7.99967 3.99333V7.99333L5.17301 10.82C6.73301 12.38 9.26634 12.38 10.833 10.82C12.393 9.25999 12.393 6.72666 10.8263 5.16666ZM7.99967 1.32666C4.31967 1.32666 1.33301 4.31333 1.33301 7.99333C1.33301 11.6733 4.31967 14.66 7.99967 14.66C11.6797 14.66 14.6663 11.6733 14.6663 7.99333C14.6663 4.31333 11.6797 1.32666 7.99967 1.32666ZM7.99967 13.3267C5.05301 13.3267 2.66634 10.94 2.66634 7.99333C2.66634 5.04666 5.05301 2.65999 7.99967 2.65999C10.9463 2.65999 13.333 5.04666 13.333 7.99333C13.333 10.94 10.9463 13.3267 7.99967 13.3267Z",
    fill: "#4B5C68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6158_35528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelapse);
export default __webpack_public_path__ + "static/media/timelapse.363378c84cb3fa7ebe9e312d855fa89f.svg";
export { ForwardRef as ReactComponent };